import { RunnerType } from 'adapters/repositories/typeDefinition';
import React, { FC, memo } from 'react';
import joy_boy from 'static/materials/joy_boy.png';
import classes from './onboardingCarousel.module.css';
import { crtYobina } from 'utils/funcs/crtYobina';

type Props = {
  runner: RunnerType;
};

export const FirstView: FC<Props> = memo(({ runner }) => {
  return (
    <>
      <div className={classes.blackBorder}>
        {crtYobina(runner)} こんにちは！
        <br />
        IDATEN Kidsへようこそ！
      </div>
      <div className={classes.joyboyWrapper}>
        <img src={joy_boy} alt=""></img>
      </div>
    </>
  );
});
